module.exports = "/_next/static/images/939377e41788899158598d7c5eacf10e-telcel-icon.svg";